import { Enrolment } from '@/models/enrolment';

import { Event } from './event';

export class EnrolmentsOrganisationChangedEvent extends Event<Enrolment[]> {}
